// formik components
import { Formik, Form } from "formik";

// Toast notifications
import { toast } from "react-toastify";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import UpdateLinkForm from "./components/updateLinkForm";

import form from "./schemas/customLink/form";
import initialValues from "./schemas/customLink/initialValues";
import validations from "./schemas/customLink/validations";

import { useUpdateParameter } from "api/features/parameter/queries";

function CustomLink(): JSX.Element {
  const { formId, formField } = form;

  const updateParameterClient = useUpdateParameter();

  const handleSubmit = (values: any, { setSubmitting }: any) => {
    setSubmitting(true);

    let hasError = false;
    updateParameterClient.mutate(
      {
        name: "NAVBAR_CUSTOM_LINK_TITLE",
        value: values.title,
      },
      {
        onError: () => {
          toast.error("Failed to update custom link.");
          hasError = true;
        },
      }
    );

    if (hasError) {
      setSubmitting(false);
      return;
    }

    updateParameterClient.mutate(
      {
        name: "NAVBAR_CUSTOM_LINK_URL",
        value: values.url,
      },
      {
        onSuccess: () => {
          toast.success("Custom link updated successfully.");
        },
        onError: () => {
          toast.error("Failed to update custom link.");
        },
      }
    );

    setSubmitting(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} mb={20}>
        <Grid container justifyContent="center" alignItems="flex-start" sx={{ mt: 8 }}>
          <Grid item xs={12} lg={6}>
            <Card>
              <MDBox p={3} display="flex" justifyContent="space-between" alignItems="center">
                <MDTypography variant="h4">Custom Link</MDTypography>
              </MDBox>
              <MDBox px={3} pb={3}>
                <MDTypography variant="body2" color="text">
                  Update custom link (
                  <Icon fontSize="small" sx={{ verticalAlign: "text-bottom", mx: 0.5 }}>
                    link
                  </Icon>
                  ) to the sidebar. This link can be used to direct users to an external resource or
                  a specific page within the application.
                </MDTypography>
              </MDBox>
              <MDBox px={3} pb={3}>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validations}
                  onSubmit={handleSubmit}
                >
                  {({ values, errors, touched, isSubmitting }) => (
                    <Form id={formId} autoComplete="off">
                      <UpdateLinkForm formData={{ formField, values, errors, touched }} />
                      <MDBox mt={2} width="100%" display="flex" justifyContent="flex-end">
                        <MDButton
                          disabled={isSubmitting || Object.keys(errors).length > 0}
                          type="submit"
                          variant="gradient"
                          color={isSubmitting || Object.keys(errors).length > 0 ? "dark" : "info"}
                        >
                          Submit
                        </MDButton>
                      </MDBox>
                    </Form>
                  )}
                </Formik>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default CustomLink;
